<div class="container-full bg-gradient">
    <div id="oauthForm">
        <mat-card>
            <img src="assets/logo-inline.png" class="logo mb-4"/>
            <mat-card-content>
                <div *ngIf="state == 'loading'" class="d-flex justify-content-center py-5">
                    <mat-spinner diameter="40"></mat-spinner>
                </div>

                <ng-container *ngIf="state == 'invalid'">
                    <h1 class="free-trial">Demande d'autorisation invalide</h1>
                    <p class="text-center mt-3">
                        Cette demande de connexion est incomplète ou provient d'une application inconnue.
                        Relancez la connexion depuis votre assistant.
                    </p>
                </ng-container>

                <ng-container *ngIf="state == 'consent'">
                    <div class="client">
                        <img *ngIf="client.logo_uri" [src]="client.logo_uri" alt="" (error)="client.logo_uri = null"/>
                        <h1 class="free-trial">
                            <a *ngIf="client.client_uri" [href]="client.client_uri" target="_blank" rel="noopener">{{ client.client_name }}</a>
                            <ng-container *ngIf="!client.client_uri">{{ client.client_name }}</ng-container>
                            souhaite accéder à votre compte LyBox
                        </h1>
                    </div>

                    <p class="account">
                        Connecté en tant que <strong>{{ authenticationService.currentUser.email }}</strong><br>
                        <a (click)="switchAccount()">Se connecter avec un autre compte</a>
                    </p>

                    <p class="mb-2">Cette application pourra, en votre nom :</p>
                    <ul class="scopes">
                        <li><i class="fa fa-search" aria-hidden="true"></i> Rechercher des annonces, analyser un lien et consulter les données d'une ville</li>
                        <li><i class="fa fa-heart" aria-hidden="true"></i> Lire et créer des favoris et des listes de favoris</li>
                        <li><i class="fa fa-map-marker" aria-hidden="true"></i> Enregistrer des secteurs</li>
                        <li><i class="fa fa-bell" aria-hidden="true"></i> Créer et modifier des recherches sauvegardées et leurs alertes mail</li>
                    </ul>
                    <p class="plan-note">Les outils nécessitent un forfait Expert ou supérieur.</p>

                    <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
                </ng-container>
            </mat-card-content>
            <mat-card-actions *ngIf="state == 'consent'">
                <button type="button" class="btn btn-outline" (click)="deny()" [disabled]="submitting">Refuser</button>
                <button type="button" class="btn btn-primary" (click)="authorize()" [disabled]="submitting">
                    <span *ngIf="submitting" class="spinner-border spinner-border-sm mr-1"></span>
                    Autoriser
                </button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>
